import { h } from '@stencil/core';
import { PageNames } from '@pes-ui/utils';
import { ICONS } from './constants';
import { isBrowser } from '../../../globals/utils';
export class BusinessLinesSe {
  constructor() {
    this.changeBusinessLineByHash = () => {
      var _a, _b, _c;
      const sourceId = this.getBusinessLineByHash();
      const index = (_a = this.linesList) === null || _a === void 0 ? void 0 : _a.findIndex((line) => (line === null || line === void 0 ? void 0 : line.sourceId) === sourceId);
      this.carouselSelectCell = index;
      if (!this.changeActiveLine) {
        return;
      }
      this.changeActiveLine((_c = (_b = this.linesList) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.id);
    };
    this.handlePopState = () => {
      this.changeBusinessLineByHash();
    };
    this.linesList = undefined;
    this.selectBl = undefined;
    this.topTangesLabel = undefined;
    this.viewOnLabel = undefined;
    this.productsLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.seeAllOffersLink = undefined;
    this.mostViewedProductsLabel = undefined;
    this.learnMoreLabel = undefined;
    this.business = undefined;
    this.activeLine = undefined;
    this.isMobile = undefined;
    this.changeActiveLine = undefined;
    this.disableBusinessLinesHashRouting = false;
    this.breadcrumbs = undefined;
    this.storageName = undefined;
    this.isPBS = false;
    this.carouselSelectCell = -1;
  }
  activeLineChanged(activeLine) {
    if (!isBrowser())
      return;
    if (!this.isPBS && !this.disableBusinessLinesHashRouting) {
      this.pushBusinessLinesState(activeLine);
    }
    this.emitBusinessLineDidChangeEvent(activeLine);
  }
  pushBusinessLinesState(activeLine) {
    const { sourceId } = activeLine !== null && activeLine !== void 0 ? activeLine : {};
    let hash = '#';
    if (sourceId) {
      hash = sourceId.startsWith('/') ? `#${sourceId}` : `#/${sourceId}`;
    }
    window.history.pushState(null, hash, hash);
  }
  emitBusinessLineDidChangeEvent(activeLine) {
    const eventData = [];
    const activeBusinessLine = activeLine;
    if (activeBusinessLine) {
      eventData.push({
        id: activeBusinessLine.sourceId,
        name: activeBusinessLine.name,
        itemType: PageNames.BUSINESS,
        url: null,
      });
    }
    this.pesBreadcrumbsTailDidAppend.emit(eventData);
  }
  initBusinessLinesRouting() {
    this.changeBusinessLineByHash();
    window.addEventListener('popstate', this.handlePopState);
  }
  getBusinessLineByHash() {
    return window.location.hash.replace(/^#?\//, '');
  }
  connectedCallback() {
    if (!isBrowser())
      return;
    if (this.isPBS || this.disableBusinessLinesHashRouting)
      return;
    this.initBusinessLinesRouting();
  }
  disconnectedCallback() {
    if (!isBrowser())
      return;
    window.removeEventListener('popstate', this.handlePopState);
  }
  render() {
    return (h("pes-business-lines-view", { linesList: this.linesList, topTangesLabel: this.topTangesLabel, viewOnLabel: this.viewOnLabel, productsLabel: this.productsLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, seeAllOffersLink: this.seeAllOffersLink, mostViewedProductsLabel: this.mostViewedProductsLabel, learnMoreLabel: this.learnMoreLabel, business: this.business, activeLine: this.activeLine, isMobile: this.isMobile, iconNameMap: ICONS, carouselSelectCell: this.carouselSelectCell, onBusinessLineDidClick: ({ detail }) => this.selectBl(detail === null || detail === void 0 ? void 0 : detail.id, detail === null || detail === void 0 ? void 0 : detail.sourceId), isPBS: this.isPBS }));
  }
  static get is() { return "pes-business-lines-se"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["business-lines-se.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["business-lines-se.css"]
    };
  }
  static get properties() {
    return {
      "linesList": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllBusinesses[]",
          "resolved": "ProductsAllBusinesses[]",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "selectBl": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(id: string, sourceId: string) => void",
          "resolved": "(id: string, sourceId: string) => void",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "topTangesLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "top-tanges-label",
        "reflect": false
      },
      "viewOnLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-on-label",
        "reflect": false
      },
      "productsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-label",
        "reflect": false
      },
      "productRelationsViewProdLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-relations-view-prod-label",
        "reflect": false
      },
      "seeAllOffersLink": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "see-all-offers-link",
        "reflect": false
      },
      "mostViewedProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "most-viewed-products-label",
        "reflect": false
      },
      "learnMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "learn-more-label",
        "reflect": false
      },
      "business": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllCategoriesCategory[]",
          "resolved": "ProductsAllCategoriesCategory[]",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "activeLine": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllBusinesses",
          "resolved": "{ url?: string; categories?: ProductsAllCategories[]; id?: string; name?: string; sourceId?: string; toprunners?: ProductsAllToprunners[]; }",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isMobile": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile",
        "reflect": false
      },
      "changeActiveLine": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(id?: string) => void",
          "resolved": "(id?: string) => void",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "disableBusinessLinesHashRouting": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disable-business-lines-hash-routing",
        "reflect": false,
        "defaultValue": "false"
      },
      "breadcrumbs": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBreadcrumbs[]",
          "resolved": "TBreadcrumbs[]",
          "references": {
            "TBreadcrumbs": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "breadcrumbs array for saving in indexDB"
        }
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "carouselSelectCell": {}
    };
  }
  static get events() {
    return [{
        "method": "pesBreadcrumbsTailDidAppend",
        "name": "pesBreadcrumbsTailDidAppend",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TBreadcrumbs[]",
          "resolved": "TBreadcrumbs[]",
          "references": {
            "TBreadcrumbs": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        }
      }];
  }
  static get watchers() {
    return [{
        "propName": "activeLine",
        "methodName": "activeLineChanged"
      }];
  }
}
